import type { ReactNode } from 'react'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'

/** The bottom sheet (a dialog below 768 px) around one edit form: [Annuleren] and [Overnemen]. */
export function SheetFrame({
  title,
  description,
  onSave,
  onClose,
  saveDisabled = false,
  children,
}: {
  title: string
  description?: string
  onSave: () => void
  onClose: () => void
  saveDisabled?: boolean
  children: ReactNode
}) {
  return (
    <Dialog open onOpenChange={(open) => (open ? undefined : onClose())}>
      <DialogContent size="md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description ?? 'Wat je hier aanpast, wordt pas vastgelegd met Vastleggen.'}</DialogDescription>
        </DialogHeader>
        <form
          className="flex max-h-[65svh] flex-col gap-4 overflow-y-auto"
          onSubmit={(event) => {
            event.preventDefault()
            if (!saveDisabled) onSave()
          }}
        >
          {children}
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>
              Annuleren
            </Button>
            <Button type="submit" disabled={saveDisabled}>
              Overnemen
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}
